import { useMemo } from 'react';

import useForm from '../utils/useForm';

const useClaimDocumentForm = (onSubmit, isPhoto) => {
  const submitHandler = (formValues, actions) => {
    onSubmit(formValues);
    actions.resetForm();
  };

  const fields = useMemo(
    () => [
      {
        title: 'Upload Document',
        isTitleHidden: true,
        fields: [
          {
            title: isPhoto ? 'Photo upload' : 'Document upload',
            name: 'files',
            type: isPhoto ? 'image' : 'docUploader',
            required: true,
            className: 'col-span-full',
            multiple: true,
            accept: isPhoto ? 'image/*' : 'application/pdf',
          },
        ],
      },
    ],
    [isPhoto]
  );

  return useForm({ fields, onSubmit: submitHandler });
};

export default useClaimDocumentForm;
